const graphColors = (): string[] => {
  // get css variables
  var style = getComputedStyle(document.body);
  const primaryColor = style.getPropertyValue('--primary-color') || '#363E44';
  const secondaryColor = style.getPropertyValue('--secondary-color') || '#47AD4D';

  return [secondaryColor, primaryColor, '#232D64'];
};

export { graphColors };
